export const ROCK_HALL_PLACE = {
  "@type": "Place",
  name: "Rock & Roll Hall of Fame",
  address: {
    "@type": "PostalAddress",
    streetAddress: "1100 Rock & Roll Blvd",
    addressLocality: "Cleveland",
    addressRegion: "OH",
    postalCode: "44114",
    addressCountry: "US",
  },
} as const;
